import React from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from 'react-metrics';

import CountryBar from './footer-countrybar';
import Drawer from '../drawer';
import Accordion from '../../../shared/components/accordion';
import Link from '../../../shared/components/hyperlink';
import AccordionContainer from '../../../shared/components/accordion-container';
import Icon from './icon';
import ButtonIcon from './button-icon';

import './footer-mobile.less';


function FooterMobile({ footer, showCountries, onToggleCountries, onCloseCountries }) {
    return (
        <div className="footer-mobile">
            <CountryBar onToggleCountries={onToggleCountries} countryFlagUrl={footer.countryFlagUrl} countryName={footer.countryName}>
                <Drawer open={showCountries} onClose={onCloseCountries} left push>
                    <MetricsElement element="div" className="country-container-menu">
                        <div className="country-header">
                            <div>Select Your Country/Region and Language</div>
                            <ButtonIcon
                                buttonClass="button-close"
                                icon="icon-close"
                                onClick={onCloseCountries}
                                ariaLabel="Close Country Select"
                            >
                                X
                            </ButtonIcon>
                        </div>
                        <AccordionContainer>
                            {Object.entries(footer.countries).map(([region, countries], gi) => (
                                <Accordion title={region} key={gi}>
                                    <div>
                                        {countries.map((c, i) => (
                                            <MetricsElement element="div" key={i}>
                                                <Link to={c.countryUrl}>{c.countryTitle}</Link>
                                            </MetricsElement>
                                        ))}
                                    </div>
                                </Accordion>
                            ))}
                        </AccordionContainer>
                    </MetricsElement>
                </Drawer>
            </CountryBar>
            <AccordionContainer>
                {footer.groups.map((group, groupKey) => (
                    <Accordion title={group.name} key={groupKey} accordionKey={groupKey}>
                        <MetricsElement element="div">
                            {group.link && (
                                <Link
                                    data-metrics-event-name="linkClick"
                                    data-metrics-event={group.analyticsLinkType}
                                    data-metrics-link-id={group.analyticsLinkID}
                                    data-metrics-link-placement={"footer"}
                                    to={group.link}
                                >
                                    {group.name}
                                </Link>
                            )}
                            {group.items.map((item, itemKey) => (
                                <Link
                                    data-metrics-event-name="linkClick"
                                    data-metrics-event={item.analyticsLinkType}
                                    data-metrics-link-id={item.analyticsLinkID}
                                    data-metrics-link-placement={"footer"}
                                    to={item.link}
                                    key={itemKey}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </MetricsElement>
                    </Accordion>
                ))}
                <Accordion title={footer.social.name} accordionKey="social">
                    <MetricsElement element="ul" className="social-links">
                        {footer.social.items.map((item, socialKey) => (
                            <li key={socialKey}>
                                <Link
                                    data-metrics-event-name="linkClick"
                                    data-metrics-event={item.analyticsLinkType}
                                    data-metrics-link-id={item.analyticsLinkID}
                                    data-metrics-link-placement={"footer"}
                                    to={item.link}
                                    key={socialKey}
                                    aria-label={item.icon.replace('aem-', '')}
                                >
                                    <Icon icon={item.icon} />
                                </Link>
                            </li>
                        ))}
                    </MetricsElement>
                </Accordion>
            </AccordionContainer>
        </div>
    );
}

FooterMobile.defaultProps = {
    showCountries: false,
};

FooterMobile.propTypes = {
    /** footer data object */
    footer: PropTypes.object.isRequired,
    /** initial show countries state */
    onToggleCountries: PropTypes.func.isRequired,
    /** close country content event */
    onCloseCountries: PropTypes.func.isRequired,
    /** toggle country content */
    showCountries: PropTypes.bool,
};

export default FooterMobile;
